// Module
var code = "<p>קודם כל, תודה שאכפת לכם. במידה ומצאתם פרטים שגויים או מודעות פיקטיביות, ספרו לנו על כך! תוכלו לעשות זאת בעמוד &quot;צור קשר&quot;, אותו תמצאו בתחתית האתר.</p> ";
// Exports
export default code;